"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditableRow = props => {
  const items = [];
  for (let [key, value] of Object.entries(props.row)) {
    items.push( /*#__PURE__*/_react.default.createElement(_.EditableCell, {
      type: "text",
      list: props.list,
      name: key,
      key: key,
      rowNumber: props.rowNumber,
      value: value,
      className: "form-control",
      onChange: props.onChange
    }));
  }
  return /*#__PURE__*/_react.default.createElement("tr", null, items);
};
var _default = exports.default = EditableRow;
module.exports = exports.default;